export default __webpack_public_path__ + "static/media/your_role_s.93b6fb96.jpg";